import * as React from 'react';

/**
 * This hook is used to focus the passed in input and then clear the should focus state
 */
export function useFocusInput(
    textfieldRef: {
        current: HTMLInputElement | null | undefined;
    },
    shouldFocusInputOnMount: boolean,
    setShouldFocusInputOnMount: (arg1: boolean) => void
) {
    const [shouldFocus, setShouldFocus] = React.useState<boolean>(shouldFocusInputOnMount);

    React.useEffect(() => {
        if (shouldFocusInputOnMount && textfieldRef && textfieldRef.current) {
            textfieldRef.current.select();

            // If we focused on mount, set editing to true, but tell
            // parent component that we don't want to re-focus after blurring
            if (shouldFocusInputOnMount) {
                // callback to parent to set that state to false
                setShouldFocus(false);
            }
        }
    }, [textfieldRef, shouldFocusInputOnMount, setShouldFocusInputOnMount]);

    return shouldFocus;
}
